const Entities = {
  AD_SERVER: "ad_server",
  ADVERTISER: "advertiser",
  AGENCY: "agency",
  ATOMIC_CREATIVE: "atomic_creative",
  AUDIENCE_SEGMENT: "audience_segment",
  CAMPAIGN: "campaign",
  CAMPAIGNS: "campaigns",
  CONCEPT: "concept",
  CREATIVE: "creative",
  CREATIVE_APPROVAL: "creative_approval",
  DEAL: "deal",
  DEAL_GROUPS: "deal_groups",
  ENTERPRISE_CONTROLS: "enterprise_controls",
  FIRST_PARTY_DATA: "first_party_data",
  INLINE_CAMPAIGN_EDIT: "inline_campaign",
  INLINE_STRATEGY_EDIT: "inline_strategy",
  ORGANIZATION: "organization",
  PIXEL: "pixel",
  PIXEL_ATTRIBUTE: "pixel_attribute",
  PIXEL_BUNDLE: "pixel_bundle",
  PIXEL_BUNDLES: "pixel_bundles",
  PIXEL_PROVIDER: "pixel_provider",
  PLACEMENT_SLOT: "placement_slot",
  PUBLISHER: "publisher",
  PUBLISHER_SITE: "publisher_site",
  SEGMENTS: "segments",
  SEGMENT_GROUPS: "segment_groups",
  SITE_LIST: "site_list",
  SITE_PLACEMENT: "site_placement",
  STRATEGIES: "strategies",
  STRATEGY: "strategy",
  STRATEGY_CONCEPT: "strategy_concept",
  STRATEGY_DAY_PART: "strategy_day_part",
  STRATEGY_DOMAIN: "strategy_domain",
  STRATEGY_GROUP: "strategy_group",
  STRATEGY_SUPPLY_SOURCE: "strategy_supply_source",
  SUPPLY_PATHS: "supply_paths",
  TARGET_DIMENSION: "target_dimension",
  TARGET_VALUE: "target_value",
  TARGETING_VENDOR: "targeting_vendor",
  USER: "user",
  VENDOR: "vendor",
  VENDOR_CONTRACT: "vendor_contract",
  VENDOR_DOMAIN: "vendor_domain",
  VENDOR_PIXEL: "vendor_pixel",
  VENDOR_PIXEL_DOMAIN: "vendor_pixel_domain",
  VERTICAL: "vertical",

  // Subentities
  EXCHANGE_SEAT: "seat",
  PERMISSION: "permission",
  SESSION: "session",

  // Others
  CONTRACT: "contract",
  SUPPLY_SOURCE: "supply_source",
};

export default Entities;
